import React from 'react'

export default function IndustryDesign({data}) {
  return (
    <>
      <section className="industry-design-area">
        <div className="container">
          <div className="row align-items-center justify-content-center">
            <div className="col-lg-10">
              <h2 className="heading center-heading">{data?.head}</h2>
            </div>
            <div className="col-lg-7 col-md-6 wow animate__animated animate__fadeInLeft" data-wow-duration="0.8s" data-wow-delay="0.1s">
              <div className="industry-design-img">
                <img src={data?.img} alt="Industry Design" loading='lazy' />
              </div>
            </div>

            <div className="col-lg-5 col-md-6 wow animate__animated animate__fadeInRight" data-wow-duration="0.8s" data-wow-delay="0.1s">
              <div className="industry-design-content">
                {data?.desc.map((para, index) => (
                  <p key={index}>{para}</p>
                ))}
                <ul>
                  {data?.list.map((item, index) => (
                    <li key={index}>{item}</li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}
